<template>
  <PageTemplate :loading="loading">
    <v-container class="pt-10 pb-12">
      <Title>{{ item.title }}</Title>

      <div
        v-if="item.text"
        class="text-body-2 font-weight-regular mt-8"
        v-html="item.text"
      ></div>

      <div class="mt-8 grid-list-images">
        <div
          class="grid-list-images-item"
          v-for="({ title, img, gallery }, keyItems) in items"
          :key="keyItems"
        >
          <img
            @click="
              images = gallery;
              index = 0;
            "
            :src="files + img + '?resize=1&w=600'"
            class="d-block"
            :alt="title"
          />
        </div>
      </div>
    </v-container>
    <LightGallery
      v-if="images"
      :images="images"
      :index="index"
      :disable-scroll="true"
      @close="
        index = null;
        images = [];
      "
    />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Title from "../../widgets/Title.vue";
import { LightGallery } from "vue-light-gallery";

export default {
  data: () => ({
    loading: true,
    index: null,
    images: [],
  }),
  computed: {
    item() {
      return this.$rest("cultural-space").item;
    },
    items() {
      return this.$rest("cultural-space-galleries").list.map(
        ({ img, title }) => ({
          img: img.featured,
          gallery: img.list.map(({ path }) => {
            return this.files + path;
          }),
          title,
        })
      );
    },
  },
  beforeCreate() {
    this.$rest("cultural-space").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("cultural-space-galleries")
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    PageTemplate,
    Title,
    LightGallery,
  },
};
</script>

<style lang="scss" scoped>
.grid-list-images {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
  .grid-list-images-item {
    img {
      aspect-ratio: 16 / 10;
      cursor: pointer;
      object-fit: cover;
      -o-object-fit: cover;
      width: 100%;
    }
  }
}
</style>
